module.exports = __webpack_public_path__ + "static/media/introMEGA.3cf8f75.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/home-en/introMEGA.mp4
// module id = Df+U
// module chunks = 0